export const COWS_FETCH_REQUEST = 'COWS_FETCH_REQUEST';
export const COWS_FETCH_SUCCESS = 'COWS_FETCH_SUCCESS';
export const COWS_FETCH_FAIL = 'COWS_FETCH_FAIL';
export const COWS_SET_SORT = 'COWS_SET_SORT';
export const COWS_SELECT_COW = 'COWS_SELECT_COW';
export const COWS_VIDEO_PLAY_STOP = 'COWS_VIDEO_PLAY_STOP';
export const COWS_SET_PAGE = 'COWS_SET_PAGE';
export const COWS_SET_PAGE_SIZE = 'COWS_SET_PAGE_SIZE';
